import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    host: "https://wordpress.datacivica.org/wp-json/wp/v2"
  },
  mutations: {},
  actions: {},
  modules: {}
});
